import React, { useContext, useState } from 'react'
import { SavedSearchGroup } from 'types/savedSearchTypes'
import {
  SearchCard,
  SearchActions,
  SearchButton,
  EditActionContainer,
  DeleteModalOverlay,
  DeleteModalContent,
  DeleteModalTitle,
  DeleteModalMessage,
  PopoverBody,
  PopoverFooter,
  ActionButton,
  SearchContent,
  SearchInfo,
  SearchTitle,
  SearchCount,
  // InlineLoader,
  EditActions,
  ActionLink,
  PopoverContent,
  PopoverOverlay,
  Input,
  Label,
  CloseButtonStyled,
  TitleLink
} from '../../pages/SavedSearchPage.styled'
import { Row, Col, Button } from 'react-bootstrap'
import { SavedSearchContext } from './SavedSearchContext'
import { Loader } from 'components/Loader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PencilSquare from 'images/icon/PencilSquare'
import { NotificationModal } from './NotificationModal'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { NotificationFormData } from './NotificationModal'
import { ISearchFilterResult } from 'types/vehicleTypes'
import { CriteriaGrid, CriteriaItem, CriteriaLabel, CriteriaValue } from '../../pages/SavedSearchPage.styled'
import { useClickOutSide } from 'hooks/useClickOutSide'
const DEFAULT_NOTIFICATION_FORM: NotificationFormData = {
  notifyMe: false,
  emailFormat: true,
  emailRecurrence: 1,
  emailDay: 1,
  emailRecurrenceDuration: 1
}

interface SavedSearchCardProps {
  search: SavedSearchGroup
}
type ModelType = 'edit-name' | 'edit-notification' | 'delete-confirm' | null
const SavedSearchCard: React.FC<SavedSearchCardProps> = ({ search }) => {
  const {
    saving,
    loading,
    selectedSearch,
    handleDeleteSearch,
    handleDeleteConfirm,
    handleEditSearchName,
    handleEditNotification,
    handleSaveSearchName,
    handleSaveNotifications,
    searchFrequencies,
    searchDays,
    searchDurations,
    runSearch,
    closeAllModals
  } = useContext(SavedSearchContext)
  const [editSearchName, setEditSearchName] = useState('')
  const [notificationFormData, setNotificationFormData] = useState<NotificationFormData>(DEFAULT_NOTIFICATION_FORM)
  const [activeModal, setActiveModal] = useState<ModelType>(null)
  const searchNamePopoverRef = React.useRef<HTMLDivElement>(null)
  const notificationPopoverRef = React.useRef<HTMLDivElement>(null)
  const deleteConfirmPopoverRef = React.useRef<HTMLDivElement>(null)

  useClickOutSide(deleteConfirmPopoverRef, () => setActiveModal(null))
  useClickOutSide(searchNamePopoverRef, () => setActiveModal(null))
  const handleEditSearchNameAction = (searchItem: SavedSearchGroup) => {
    handleEditSearchName(searchItem)
    setEditSearchName(searchItem.Description)
    setNotificationFormData(DEFAULT_NOTIFICATION_FORM)
    setActiveModal('edit-name')
  }

  const handleEditNotificationAction = (searchItem: SavedSearchGroup) => {
    handleEditNotification(searchItem)
    setEditSearchName('')
    setNotificationFormData({
      notifyMe: searchItem.NotifyMe,
      emailFormat: searchItem.EmailFormat,
      emailRecurrence: searchItem.EmailRecurrance || 1,
      emailDay: searchItem.EmailDay || 1,
      emailRecurrenceDuration: searchItem.EmailRecurranceDuration || 1
    })
    setActiveModal('edit-notification')
  }

  const handleDeleteSearchAction = (searchItem: SavedSearchGroup) => {
    handleDeleteSearch(searchItem)
    setActiveModal('delete-confirm')
  }

  const handleCloseAllModals = () => {
    closeAllModals()
    setEditSearchName('')
    setNotificationFormData(DEFAULT_NOTIFICATION_FORM)
    setActiveModal(null)
  }

  const handleSaveSearchNameAction = () => {
    handleSaveSearchName(editSearchName)
    setEditSearchName('')
    setActiveModal(null)
  }

  const handleSaveNotificationsAction = () => {
    handleSaveNotifications(notificationFormData)
    setNotificationFormData(DEFAULT_NOTIFICATION_FORM)
    setActiveModal(null)
  }

  const handleDeleteConfirmAction = () => {
    handleDeleteConfirm()
    setActiveModal(null)
  }
  const renderSearchCriteria = (filters: ISearchFilterResult[]): React.ReactNode => {
    if (!filters || filters.length === 0) return null
    const selectedFilters = filters.filter((filter) => filter.Selected)
    if (selectedFilters.length === 0) return null

    return (
      <CriteriaGrid>
        {selectedFilters.map((filter, index) => (
          <CriteriaItem key={index}>
            <CriteriaLabel>{filter.GroupName === 'Fuel Type' ? 'FuelType' : filter.FieldName}:</CriteriaLabel>
            <CriteriaValue>{filter.FriendlyValue}</CriteriaValue>
          </CriteriaItem>
        ))}
      </CriteriaGrid>
    )
  }
  const isEditSearchNameModalOpen = activeModal === 'edit-name' && selectedSearch?.ID === search.ID
  const isEditNotificationModalOpen = activeModal === 'edit-notification' && selectedSearch?.ID === search.ID
  const isDeleteConfirmModalOpen = activeModal === 'delete-confirm' && selectedSearch?.ID === search.ID
  return (
    <>
      <SearchCard>
        <CloseButtonStyled onClick={() => handleDeleteSearchAction(search)}>✕</CloseButtonStyled>
        {isDeleteConfirmModalOpen && (
          <DeleteModalOverlay ref={deleteConfirmPopoverRef}>
            <DeleteModalContent>
              <PopoverBody>
                <DeleteModalTitle>Delete Search</DeleteModalTitle>
                <DeleteModalMessage>ARE YOU SURE YOU WISH TO DELETE THIS SEARCH?</DeleteModalMessage>
              </PopoverBody>
              <PopoverFooter>
                {/* <Button variant="light form-btn"></Button> */}
                <Button variant="light form-btn" onClick={handleCloseAllModals}>
                  Cancel
                </Button>
                <ActionButton onClick={handleDeleteConfirmAction} disabled={saving}>
                  Delete
                </ActionButton>
              </PopoverFooter>
            </DeleteModalContent>
          </DeleteModalOverlay>
        )}
        <Row>
          <Col>
            <SearchTitle>
              <TitleLink
                onClick={(event) => {
                  runSearch(search)
                  event.stopPropagation()
                }}
              >
                {search.Description}
              </TitleLink>
              <SearchCount>({search.searchIsRunning ? <Loader /> : search.vehicleCount})</SearchCount>
            </SearchTitle>

            <EditActions>
              <EditActionContainer>
                <ActionLink onClick={() => handleEditSearchNameAction(search)}>
                  <FontAwesomeIcon className="icon" icon={faPencilAlt} />
                  Edit Search Name
                </ActionLink>
                {isEditSearchNameModalOpen && (
                  <PopoverOverlay ref={searchNamePopoverRef}>
                    <PopoverContent>
                      <PopoverBody>
                        <Label htmlFor="searchNameInput">Enter Search Name</Label>
                        <Input
                          id="searchNameInput"
                          type="text"
                          value={editSearchName}
                          onChange={(e) => setEditSearchName(e.target.value)}
                          placeholder="Enter search name"
                          autoFocus
                        />
                      </PopoverBody>
                      <PopoverFooter>
                        <Button variant="light form-btn" onClick={handleCloseAllModals}>
                          Cancel
                        </Button>
                        <ActionButton onClick={handleSaveSearchNameAction}>Save</ActionButton>
                      </PopoverFooter>
                    </PopoverContent>
                  </PopoverOverlay>
                )}
              </EditActionContainer>
              <EditActionContainer>
                <ActionLink onClick={() => handleEditNotificationAction(search)}>
                  <PencilSquare />
                  Edit Notifications
                </ActionLink>
                <NotificationModal
                  isOpen={isEditNotificationModalOpen}
                  formData={notificationFormData}
                  onFormChange={setNotificationFormData}
                  dropdownData={{
                    searchFrequencies,
                    searchDays,
                    searchDurations
                  }}
                  onSave={handleSaveNotificationsAction}
                  onCancel={handleCloseAllModals}
                  saving={saving}
                  forwardRef={notificationPopoverRef}
                />
              </EditActionContainer>
            </EditActions>
          </Col>

          <Col md={6} lg={6}>
            <SearchContent>
              <SearchInfo>Search for the following criteria:</SearchInfo>
              {renderSearchCriteria(search.Filters || [])}
            </SearchContent>
          </Col>

          <SearchActions>
            <Row>
              <SearchButton
                onClick={() => {
                  runSearch(search)
                }}
              >
                Search Now
              </SearchButton>
            </Row>
          </SearchActions>
        </Row>
      </SearchCard>
    </>
  )
}

export default SavedSearchCard
